const mockPromotionsData = [
    {
        "id": 30,
        "name": "Exclusive Release - Rising Silhouette by Felix Lyric",
        "release": 476,
        "catalogue_number": "MMCO0014852",
        "score": "8.5/10",
        "send_date": "2023-11-21",
        "send_reminder": 3,
        "responses_sent_number": "112/139",
        "recipients_added": 25,
        "promotion_status": "reminder"
    },
    {
        "id": 31,
        "name": "Exclusive Release - Melodic Harmony by Aster Veldt",
        "release": 476,
        "catalogue_number": "MMCO0014853",
        "score": "7/10",
        "send_date": "2023-11-28",
        "send_reminder": 3,
        "responses_sent_number": "20/29",
        "recipients_added": 18,
        "promotion_status": "reminder"
    },
    {
        "id": 32,
        "name": "Exclusive Release - Echoing Harmony by Vox Aria",
        "release": 476,
        "catalogue_number": "MMCO0014854",
        "score": "6/10",
        "send_date": "2023-11-21",
        "send_reminder": 3,
        "responses_sent_number": "27/50",
        "recipients_added": 30,
        "promotion_status": "reminder"
    },
    {
        "id": 29,
        "name": "Exclusive Release - Whispering Rhapsody by Cleo Harmonix",
        "release": 344,
        "catalogue_number": "HFR0014855",
        "score": "0/10",
        "send_date": "2022-01-21",
        "send_reminder": 2,
        "responses_sent_number": "0/0",
        "recipients_added": 20,
        "promotion_status": "ready"
    },
    {
        "id": 26,
        "name": "Exclusive Release - Rising Rhapsody by Nadia Tune",
        "release": 232,
        "catalogue_number": "RRM0014856",
        "score": "10/10",
        "send_date": "2022-03-15",
        "send_reminder": 2,
        "responses_sent_number": "112/140",
        "recipients_added": 15,
        "promotion_status": "sent"
    },
    {
        "id": 7,
        "name": "Exclusive Release - Mystic Voyage by Iris Fugue",
        "release": 35,
        "catalogue_number": "BBS0014857",
        "score": "7.5/10",
        "send_date": "2022-01-21",
        "send_reminder": 2,
        "responses_sent_number": "40/42",
        "recipients_added": 33,
        "promotion_status": "sent"
    }
]
export default mockPromotionsData;